module.exports = __webpack_public_path__ + "static/media/4.697a4647.png";